import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AuthenticationService } from '../_services';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private authenticationService: AuthenticationService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError(err => {
        let mensaje: string;
        if (err.status === 401 || err.status === 403) {
          mensaje = 'No tiene permiso';
        } else if (err.status === 400) {
          mensaje = err.error;
        } else if (err.status === 500) {
          if (err.error.error.exception !== undefined) {
            mensaje = err.error.error.exception[1].message;
          } else {
            mensaje = err.error.error.message; // error de DobroException en el api
          }
        } else if (err.status === 511) {
          // auto logout si es 511
          mensaje = err.error.error.message;
          this.authenticationService.logout(false).subscribe(data => {
            console.log('La sesión ha expirado');
          });
        }

        const error = mensaje || err.error.message || err.statusText;
        alert(error);
        console.log(error);
        return throwError(error);
      })
    );
  }
}
